import React from 'react';

const Component = props => {
	return (
		<>
			<div className='my-[50px]'>
				<h2 className='text-[30px] md:text-[25px] font-normal mb-[30px] text-[#282e3f]'>
					Présentation personnelle
				</h2>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Titulaire d'un master en droit à l'Université Catholique de Louvain après avoir obtenu son
					baccalauréat aux facultés Notre Dame de la Paix de Namur, Maître Dimitri VAN WYMEERSCH est inscrit
					au Barreau de Charleroi depuis le 5 octobre 2009.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Maître Dimitri VAN WYMEERSCH se spécialisera rapidement en droit des assurances et en dommage
					corporel, matières qu'il pratique régulièrement.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					A cette fin, il a suivi un certificat universitaire en droit des assurances à l'Université
					Catholique de Louvain.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Fort de son expérience, il donne cours aux futurs courtiers en assurances au sein du réseau IFAPME.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Tout au long de sa carrière, Maître Dimitri VAN WYMEERSCH s'est également intéressé au droit pénal
					ainsi qu'au droit de la famille et de la jeunesse où il excelle aussi.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					En 2022, il s'est associé avec Maître Jean-François GAILLY pour lequel il avait toujours collaboré
					et, forts de cette collaboration, ils ont fondé le cabinet d'avocats GAVA-<i>Lex</i>.
				</p>
				<p className='text-[#666] text-[16px] leading-[28px] mb-[20px]'>
					Maître Dimitri VAN WYMEERSCH dispose d'un cabinet secondaire à Mont-sur-Marchienne (Charleroi), rue
					des Gonceries n° 36 où il pourra éventuellement vous recevoir.
				</p>
			</div>
		</>
	);
};

export default Component;
